var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndicadoresBiodiversidadIcono(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 145.76 110.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "134.84 99.33 142.13 99.33 142.13 103.05 138.56 103.05 138.56 106.62 134.84 106.62 134.84 99.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M120.79,103.23h-10.65v-3.72h10.65v3.72ZM99.5,103.23h-10.65v-3.72h10.65v3.72ZM78.2,103.23h-10.65v-3.72h10.65v3.72ZM56.91,103.23h-10.65v-3.72h10.65v3.72ZM35.61,103.23h-10.65v-3.72h10.65v3.72Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "3.63 98.65 10.93 98.65 10.93 105.94 7.21 105.94 7.21 102.37 3.63 102.37 3.63 98.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.75,84.25h-3.72v-11.68h3.72v11.68ZM10.75,60.89h-3.72v-11.68h3.72v11.68ZM10.75,37.52h-3.72v-11.68h3.72v11.68Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "7.21 3.47 10.93 3.47 10.93 10.76 3.63 10.76 3.63 7.04 7.21 7.04 7.21 3.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "139.41 93.41 135.69 93.41 135.69 10.59 17.1 10.59 17.1 6.87 139.41 6.87 139.41 93.41"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 77.43,
    y: 22.9,
    width: 1.49,
    height: 29.54,
    transform: "translate(-6.78 55.33) rotate(-37.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 74.43,
    y: 43.11,
    width: 7.63,
    height: 1.49,
    transform: "translate(-2.11 3.99) rotate(-2.89)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 78.28,
    y: 38.48,
    width: 12.87,
    height: 1.49,
    transform: "translate(44.36 123.41) rotate(-89.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M80.58,51.63c-1.29,0-2.76-.12-4.44-.41-7.87-1.39-10.32-3.75-11.4-16.7-1-12.05-3.22-15.09-3.24-15.12l-.99-1.3,1.62.09c.83.05,20.43,1.36,24.79,7.41,8.18,11.35.95,24.03.87,24.16l-.08.13-.12.09c-.11.08-2.31,1.65-7.02,1.65ZM63.38,19.79c.82,1.87,2.14,6.07,2.85,14.6,1.06,12.7,3.35,14.16,10.17,15.36,6.38,1.13,9.55-.5,10.19-.89.75-1.4,6.27-12.48-.88-22.39-1.6-2.23-6.17-4.11-13.21-5.44-3.74-.71-7.27-1.08-9.12-1.25Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 73.05,
    y: 31.54,
    width: 6.61,
    height: 1.49,
    transform: "translate(36.15 104.79) rotate(-83.91)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 20.9,
    cy: 76.28,
    r: 4.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 37.66,
    cy: 62.34,
    r: 4.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 71.18,
    cy: 66.78,
    r: 4.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 87.94,
    cy: 51.17,
    r: 4.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 121.46,
    cy: 40.3,
    r: 4.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 104.7,
    cy: 63.39,
    r: 4.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 54.42,
    cy: 82.39,
    r: 4.02
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "54.36 83.47 37.57 63.39 21.38 76.86 20.43 75.71 37.76 61.29 54.49 81.31 87.88 50.2 104.54 62.35 120.86 39.87 122.06 40.74 104.87 64.43 88 52.13 54.36 83.47"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.33,94.44c-.45,0-.91-.17-1.27-.5-.75-.7-.79-1.88-.09-2.63l29.81-31.94,24.97,24.28,47.69-16.94c.97-.34,2.03.16,2.38,1.13.34.97-.16,2.03-1.13,2.38l-49.87,17.72-23.91-23.24-27.22,29.16c-.37.39-.86.59-1.36.59Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "121.24 82.12 118.79 80.85 125.07 68.82 112.61 63.43 113.7 60.91 128.88 67.46 121.24 82.12"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndicadoresBiodiversidadIcono);
export default __webpack_public_path__ + "static/media/indicadores-biodiversidad-icono.2fa784bf00c0f788919a1eccfdcdc29b.svg";
export { ForwardRef as ReactComponent };